<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }} </h1>
        <h2 style="visibility: hidden;opacity:0;"></h2>
      </div>
    </div>

    <div class="md-layout-item">
      <ElasticList :list="list"></ElasticList>
    </div>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";

  export default {
    components: {
      ElasticList
    },
    data() {
      return {
        list: {
          hideNewRecordButton: true,
          hideListHeader: true,
          linkRows: true,
          redirectNested: {
            parentPath: "cases",
            parentPathId: "case.id",
            path: "messages",            
          },
          pageTitle: "Messages",
          pageIcon: "email",
          listQueryId: "searchMessages",
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "input",
              click: "handleRedirectNested"
            }
          ],
          columns: {
            origin: { label: "Origin"},
            from: { label: "From"},
            to: { label: "To"},
            subject: { label: "Subject" },
            caseSubject: { label: "Case" },
            createdAt: { label: "Created", sortable: true},
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse(data) {
            let result = [];
            if (data && typeof data.searchMessages !== 'undefined' && data.searchMessages.items && data.searchMessages.items.length) {
              let items = data.searchMessages.items;
              items.forEach((item) => {
                item.caseSubject = (item.case && item.case.subject)? item.case.subject : '';
                result.push(item);
              })
            }
            return result;
          }
        },
      };
    },
  };
</script>

<style></style>
